<template>
  <v-app class="app-tabela">
    <v-card class="tabela">
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          class="input-bottom"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        @pagination="getPagination"
        :page="currentPage"
        :footer-props="{
          itemsPerPageText: '',
          'items-per-page-options': [10],
          'disable-items-per-page': true,
        }"
        :loading="loading"
        loading-text="Carregando, Por favor espere"
        :headers="headers"
        :items="indexedItems"
        :search="search"
        item-key="index"
        class="elevation-1"
        :single-expand="true"
        :expanded.sync="expanded"
        show-expand
      >
        <template v-slot:header.situacao="{ header }">
          {{ header.text }}
          <span
            v-b-tooltip.hover.right
            :title="header.tooltip"
            class="icon-tooltip"
          >
            <i class="icofont-info-circle"></i>
          </span>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td colspan="9">
            <table class="table table-interna table-interna-acompanhamento">
              <thead>
                <tr>
                  <th>CPF</th>
                  <th>CNS</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ item.cpf }}</td>
                  <td>{{ item.cns }}</td>
                </tr>
              </tbody>
            </table>
            <b-alert
              v-if="item.dt_nascimento != cidadao.dt_nascimento"
              variant="danger"
              show
              class="mt-4"
            >
              A data de nascimento registrada nesse atendimento
              {{
                item.dt_nascimento != null ? formatDate(item.dt_nascimento) : ''
              }}
              é diferente da data de nascimento atual do cidadão
              {{
                cidadao.dt_nascimento != null
                  ? formatDate(cidadao.dt_nascimento)
                  : ''
              }}.
            </b-alert>
          </td>
        </template>

        <template v-slot:[`footer.page-text`]="items">
          <div class="info-table-item tabela-esus-pec">
            <FonteSincronizadorC />
          </div>
          <span class="paginacao"
            >{{ items.pageStart }} - {{ items.pageStop }} de
            {{ items.itemsLength }} registros</span
          >
        </template>

        <template v-slot:no-data>
          <div class="alert alert-info mb-0">
            <b>Nenhuma informação encontrada.</b>
          </div>
        </template>
        <template v-slot:no-results style="padding: 0px">
          <div class="alert alert-info mb-0">
            <b>Nenhuma informação encontrada.</b>
          </div>
        </template>

        <template v-slot:item.dt_nascimento="{ item }">
          <td>{{ formatDate(item.dt_nascimento) }}</td>
        </template>
        <template v-slot:item.dt_atendimento="{ item }">
          <td>{{ formatDate(item.dt_atendimento) }}</td>
        </template>
        <template v-slot:item.dt_procedimento="{ item }">
          <td>{{ formatDate(item.dt_procedimento) }}</td>
        </template>

        <template v-slot:item.nu_ine="{ item }">
          <td>
            {{ item.nu_ine }}
            <span
              v-b-tooltip.hover.right
              :title="item.no_equipe"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </td>
        </template>
      </v-data-table>
    </v-card>
  </v-app>
</template>

<script>
import utils from '@/mixins/utils.js'

export default {
  name: 'HistoricoCadastral',
  props: {
    cidadao: {
      type: Object,
      default: () => null,
    },
    filtroAtendimento: {
      type: Object,
      default: () => ({ filtro: null, operador: '>=', data: '' }),
    },
  },
  mixins: [utils],
  data() {
    return {
      expanded: [],
      headers: [
        {
          text: 'ID',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'id',
        },
        {
          text: 'DATA',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'dt_registro',
        },
        {
          text: 'SAÍDA',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'situacao',
          tooltip: 'Tipo de saída do cidadão do cadastro.',
        },
        {
          text: 'CADASTRANTE',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'prof_cadastrante',
        },
        {
          text: 'EQUIPE',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'nu_ine',
        },
        {
          text: 'MICROÁREA',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'nu_micro_area',
        },
        { text: '', value: 'data-table-expand' },
      ],
      cadastros: [],
      currentPage: 1,
      search: '',
      loading: false,
    }
  },
  mounted() {
    this.buscarDados()
  },
  computed: {
    cadastrosFiltrados() {
      const { operador, data, usarFiltroData } = this.filtroAtendimento || {}

      // sem filtro ativo
      if (!usarFiltroData || !data || !operador) {
        return this.cadastros
      }

      return this.cadastros

      // return this.cadastros.filter((item) => {
      //   const dataItem = item.dt_registro.split('/').reverse().join('-')
      //   return this._compareDates(dataItem, data, operador)
      // })
    },

    indexedItems() {
      return this.cadastrosFiltrados.map((item, index) => ({
        index,
        ...item,
      }))
    },
  },
  methods: {
    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Compara duas datas no formato YYYYMMDD.
     * @param {String} aYmd Primeira data
     * @param {String} bYmd Segunda data
     * @param {String} op Operador de comparação
     * @returns {Boolean}
     */
    _compareDates(aYmd, bYmd, op) {
      if (!aYmd || !bYmd) return true
      switch (op) {
        case '>':
          return aYmd > bYmd
        case '<':
          return aYmd < bYmd
        case '>=':
          return aYmd >= bYmd
        case '<=':
          return aYmd <= bYmd
        case '=':
          return aYmd === bYmd
        default:
          return true
      }
    },

    /**
     * Busca os dados
     */
    async buscarDados() {
      try {
        this.cadastros = []
        this.loading = true
        const response = await this.$api.get(
          `/app/cidadao/${this.$store.state.cod_ibge}/${this.cidadao.nu_cpf}/${this.cidadao.nu_cns}/cadastros`
        )
        if (response) {
          this.cadastros = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style></style>
